import React from 'react';
import PropTypes from 'prop-types';
import AlertSummaryCard from './alertSummaryCard';
import AlertDetailsCard from './alertDetailsCard';

var AlertDetails = function AlertDetails(_ref) {
  var alert = _ref.alert;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AlertSummaryCard, {
    alert: alert
  }), /*#__PURE__*/React.createElement(AlertDetailsCard, {
    alert: alert
  }));
};

AlertDetails.propTypes = {
  alert: PropTypes.object
};
export default AlertDetails;